const countUp = {
  parse(el) {
    const raw = el.textContent.trim();
    const match = raw.match(/([\D]*)([\d,.']+)([\D]*)/);
    if (!match) return null;

    const prefix = match[1];
    const numStr = match[2];
    const suffix = match[3];
    const separator = numStr.includes(',') ? ',' : numStr.includes('.') ? '.' : numStr.includes("'") ? "'" : '';
    const value = parseFloat(numStr.replace(/[,.']/g, ''));

    if (isNaN(value)) return null;

    return { prefix, suffix, separator, value, originalNumStr: numStr };
  },

  format(value, separator, originalNumStr) {
    const parts = originalNumStr.split(/[.,]/);
    const lastPart = parts[parts.length - 1] || '';
    const decimals = parts.length > 1 && lastPart.length < 3 ? lastPart.length : 0;
    const fixed = value.toFixed(decimals);

    if (!separator) return fixed;

    const [int, dec] = fixed.split('.');
    const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return dec !== undefined ? `${formatted}${separator}${dec}` : formatted;
  },

  easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  },

  animate(el, parsed, duration = 1800) {
    const { prefix, suffix, separator, value, originalNumStr } = parsed;
    const start = performance.now();

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const current = value * this.easeOutQuart(progress);

      el.textContent = prefix + this.format(current, separator, originalNumStr) + suffix;

      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  },

  init() {
    const elements = document.querySelectorAll('.is-style-count-up');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const parsed = this.parse(entry.target);
          if (parsed) this.animate(entry.target, parsed);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.3 },
    );

    elements.forEach((el) => observer.observe(el));
  },
};

export default countUp;
